
              // MODAL EVENTS START
              $( document )
              .on(`click`, `.customBadgesPlace__item[popup="true"]`, function( e ) {
                try {
                  e.stopImmediatePropagation();
                  const getBlockID = $( this ).attr( `block` );
                  $( `.modalDialog[block="${ getBlockID }"]` ).fadeIn();
                  const isIframeAvailable = $( `.modalDialog[block="${ getBlockID }"] .modalDialog__centerCenter__content--detail iframe` ).length;
                  const isIframeOldSrcAvailable = $( `.modalDialog[block="${ getBlockID }"] .modalDialog__centerCenter__content--detail iframe[src-old]` ).length;
                  if ( isIframeAvailable > 0 && isIframeOldSrcAvailable > 0 ) {
                    const videoSrc = $( `.modalDialog[block="${ getBlockID }"] .modalDialog__centerCenter__content--detail iframe` ).attr( `src-old` );
                    $( `.modalDialog[block="${ getBlockID }"] .modalDialog__centerCenter__content--detail iframe` )
                      .removeAttr( `src-old` )
                      .attr( `src`, videoSrc );
                  }
                } catch ( err ) {
                  //console.log( `ERROR .customBadgesPlace__item[popup="true"]`, err.message );
                }
              })
              .on(`click`, `.modalDialog__centerCenter__close`, function( e ) {
                try {
                  e.stopImmediatePropagation();
                  $( this ).closest( `.modalDialog` ).fadeOut();
                  const isIframeAvailable = $( this ).closest( `.modalDialog` ).find( `.modalDialog__centerCenter__content--detail iframe` ).length;
                  if ( isIframeAvailable > 0 ) {
                    const videoSrc = $( this ).closest( `.modalDialog` ).find( `.modalDialog__centerCenter__content--detail iframe` ).attr( `src` );
                    $( this ).closest( `.modalDialog` ).find( `.modalDialog__centerCenter__content--detail iframe` )
                      .removeAttr( `src` )
                      .attr( `src-old`, videoSrc );
                  }
                } catch ( err ) {
                  //console.log( `ERROR .modalDialog__centerCenter__close`, err.message );
                }
              })
              ;
              // MODAL EVENTS END
            